import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IFinanceListItem } from '../types';
import {
  FINANCE_LIST_API_URL_ADMIN,
  FINANCE_LIST_API_URL_AFFILIATE,
  FINANCE_LIST_QUERY_KEY,
  FINANCE_PERMISSIONS,
} from '../constants';

export default function useFinanceListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IFinanceListItem>, Error> {
  const { isAdminNamespace } = useCurrentNamespace();
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IFinanceListItem>>({
    queryKey: [FINANCE_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IFinanceListItem>>(
      isAdminNamespace.value ? FINANCE_LIST_API_URL_ADMIN : FINANCE_LIST_API_URL_AFFILIATE,
      tableState.value,
      {
        signal,
        permission: FINANCE_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
